import { Goal } from 'superlikers-microsites-api'

/**
 * Adapta un Goal externo al modelo interno Sprint
 * Se encarga de transformar la estructura y tipos de datos
 *
 * @param {string} userUid - Identificador único del usuario al que pertenece el sprint
 * @param {Goal} goal - Objeto Goal externo a transformar
 * @returns {Sprint} Objeto Sprint con los datos transformados
 */
export const adapterSprint = (userUid: string, goal: Goal) => ({
  id: goal._id,
  name: goal.name,
  image: goal.image.url,
  description: goal.desc,
  start_date: new Date(goal.starts_at),
  end_date: new Date(goal.ends_at),
  points: Number(goal.formula),
  progress: goal.status,
  userUid
})
